module.exports = __webpack_public_path__ + "static/media/St Albans Wardrobes Stairs.ee675a2b.JPG";